export default {
    meta: {
        title: '推荐列表',
        url: '/shoprecommend',
        urlName: '开店区域推荐' // 埋点字段，上报归属的模块
    }
};
